export const DELIVERY_TIME_PREMIUM_FEE = '06:00 AM';

export const MINIMUM_DAYS_OF_RENT = 1;
export const MAXIMUM_DAYS_OF_RENT = 21;

export const NIGHTS1TO3_MINIMUM_DAYS = 1;
export const NIGHTS1TO3_MAXIMUM_DAYS = 3;

export const NIGHTS4TO7_MINIMUM_DAYS = 4;
export const NIGHTS4TO7_MAXIMUM_DAYS = 7;

export const NIGHTS8TO10_MINIMUM_DAYS = 8;
export const NIGHTS8TO10_MAXIMUM_DAYS = 10;

export const NIGHTS11TO14_MINIMUM_DAYS = 11;
export const NIGHTS11TO14_MAXIMUM_DAYS = 14;

export const NIGHTS15TO18_MINIMUM_DAYS = 15;
export const NIGHTS15TO18_MAXIMUM_DAYS = 18;

export const NIGHTS19TO21_MINIMUM_DAYS = 19;
export const NIGHTS19TO21_MAXIMUM_DAYS = 21;

export const DEFAULT_DISCOUNT_MULTIPLE_STROLLERS = 10;
